import { Component, Input } from '@angular/core';
import SwiperCore, {
    Autoplay,
    Pagination,
    Scrollbar,
    Virtual,
    Navigation,
} from 'swiper';

SwiperCore.use([Pagination, Scrollbar, Autoplay, Virtual, Navigation]);

@Component({
    selector: 'app-offer-strip-carousel',
    templateUrl: './offer-strip-carousel.component.html',
    styleUrls: ['./offer-strip-carousel.component.scss'],
})
export class OfferStripCarouselComponent {
    isMobileWeb = false;

    @Input() item: any;
    @Input() getStylesFn!: (padding: any) => { [style: string]: any };

    constructor() {
        this.isMobileWeb =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            );
    }

    getSlidesPerView(): number {
        const sliderLength = this.item.layoutContent?.slider?.length || 0;

        if (this.isMobileWeb || sliderLength <= 1) return 1;
        if (sliderLength === 2) return 2;
        return 3;
    }
}
